import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addressesAPI } from '../api/address';
import { ICreateAddress } from '../types/Adresses';
import { custonSooner } from '../../../components/CustopmSooner';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearEditAddress } from '../../../store/slices/editAddres';
import { captureApiError } from '../../../lib/sentry-utils';

export const useEditAddress = (id: string) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (body: ICreateAddress) =>
      await addressesAPI.editAddress(body, id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['addresses'] });
      custonSooner.success('Адрес успешно изменен!');
      dispatch(clearEditAddress());
      navigate('/profile/addresses');
    },
    onError: (error: any) => {
      console.error('EditAddress error:', JSON.stringify(error, Object.getOwnPropertyNames(error), 2));
      captureApiError(error, `/api/addresses/edit/${id}`, 'PUT');
      
      if (error?.response?.status === 401) {
        custonSooner.error('Необходимо войти в систему');
        navigate('/');
      } else {
        custonSooner.error(error?.response?.data?.message || error?.message || 'Что то пошло не так');
      }
    },
  });
  return {
    editAddress: mutateAsync,
    isPending,
  };
};
